// The RING — the app's ONE spinner (user call 2026-10-01, "best practice,
// optimal, premium loader"): a faint full TRACK and a round-capped ARC in
// a 120 box, `pathLength="100"` on the arc so its dashes are percentages.
// The markup only; the motion is the host's to switch on (index.css "the
// RING"): `.spinner.on` turns the box once every 1.5s while the arc breathes
// between a dot and two thirds of the lap — the familiar chasing arc —
// and the keyframes `spin-turn` / `spin-breathe` / `spin-close` are there
// for a host that drives the states itself (the wall's masthead,
// pages/Login, which also closes the arc into a full circle on an
// accepted code). Inks through `--spinner-track` / `--spinner-ink` on the host.
// Under reduced motion a turning ring stands whole and still.
//
// Two hosts: the wall's wait and the app loader (components/AppLoader —
// the reload, the verify, a cold chunk). The Lab's wait keeps its staged
// ledger and never a spinner (design guide §4).
//
// THE CLASS IS `spinner`, NOT `ring` (measured 2026-10-15): Tailwind is
// configured as a token mirror only, but its utilities are still
// generated for every class name found in the JSX — and `ring` IS a
// Tailwind utility, a 3px blue box-shadow, which framed the loader's
// spinner in a pale blue square. Never name a class after a Tailwind
// utility (apps/web/CLAUDE.md).
export default function Ring({ className = "", on = false }) {
  return (
    <svg
      className={`spinner${on ? " on" : ""}${className ? ` ${className}` : ""}`}
      viewBox="0 0 120 120"
      aria-hidden="true"
      focusable="false"
    >
      <circle className="spinner-track" cx="60" cy="60" r="54" />
      <circle className="spinner-arc" cx="60" cy="60" r="54" pathLength="100" />
    </svg>
  );
}
